import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { throwError, Observable, catchError } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class EmployeesService {
  tokenObjectString = JSON.parse(localStorage.getItem('currentAdmin') || '');

  constructor(private httpClient: HttpClient) { }
  private handleError(error: any) {
    return throwError(error);
  }

  // Get Employee List
  getEmployee(pageIndex: any, limit: any, searchFilter: any,): Observable<any> {
    const filter = searchFilter ? '&search=' + searchFilter : ''
    return this.httpClient
      .get(environment.baseURL + `/employee?page=${pageIndex}&limit=${limit}${filter}`)
      .pipe(catchError(this.handleError));
  }

  // Employee By Id
  GetEmployeeById(userId: number): Observable<any> {
    return this.httpClient
      .get(environment.baseURL + `/employee/${userId}`)
      .pipe(catchError(this.handleError));
  }

  // Get Role
  GetRole(): Observable<any> {
    return this.httpClient
      .get(environment.baseURL + `/roles?pagination=0&status=1`)
      .pipe(catchError(this.handleError));
  }

  // Create Employee
  CreateEmployee(data: any): Observable<any> {
    return this.httpClient
      .post(environment.baseURL + `/employee/create`, data)
      .pipe(catchError(this.handleError));
  }

  // Delete Employee
  DeleteEmployee(userId: number): Observable<any> {
    return this.httpClient
      .delete(environment.baseURL + `/employee/${userId}/delete`)
      .pipe(catchError(this.handleError));
  }

  // Update Employee
  UpdateEmployee(Id: any, data: any): Observable<any> {
    return this.httpClient
      .put(environment.baseURL + `/employee/${Id}/update`, data)
      .pipe(catchError(this.handleError));
  }

  // Add Bouns
  AddBonus(userId: any, obj: any): Observable<any> {
    return this.httpClient
      .get(environment.baseURL + `/company/addcompanybonouspoints?user_id=${userId}&bonus_coins=${obj.bonus_coins}&bonus_msg=${obj.bonus_msg}`,)
      .pipe(catchError(this.handleError));
  }
  
  // Profile Update
  ProfileUpdate(data: any): Observable<any> {
    return this.httpClient
      .post(environment.baseURL + `/auth/profile`, data,)
      .pipe(catchError(this.handleError));
  }
}
